import log from 'loglevel'
import { isNil } from 'lodash/fp'
// import { type fetchUtils } from 'react-admin'

// import apiKeys from './apiKey.json'

const env = process.env['REACT_APP_ENV'] as string
const baseName = 'miraiz-connect.jp'
const zoneName = `${ { prd: '', stg: '', int: 'dev.', dev: 'dev.', exp: 'dev.' }[env] as string
    }${baseName}`
const domainName = `api${ { prd: '', stg: '-stg', int: '-int', dev: '', exp: '-exp' }[env] as string
    }.form-builder.${zoneName}`
export const url = !isNil(process.env['REACT_APP_LOCAL'])
  ? 'http://localhost:14001/v1'
  : `https://${domainName}/v1`
// const apiKey = apiKeys[env as keyof typeof apiKeys]
log.setLevel(log.levels.DEBUG)

// export const getCustomHeaders = (
//   options: fetchUtils.Options = {}
// ): Headers | undefined => {
//   const customHeaders = (
//     !isNil(options.headers)
//       ? options.headers
//       : new Headers({
//           Accept: 'application/json'
//         })
//   ) as Headers
//   customHeaders.set('X-API-Key', apiKey)
//   return customHeaders
// }
